import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Sentry from '@banking/ui/services/sentry';
import { Severity } from '@sentry/browser';

export default class SignupRoute extends Route {
  @service sentry!: Sentry;

  redirect() {
    // Sentry should automatically include the URL as a tag
    this.sentry.captureMessage(
      'Encountered an unrecognized URL',
      Severity.Info
    );
    this.replaceWith('signup.index');
  }
}
